import './Footer.css';
import '../GroupList/GroupList.css';

import React, { useContext, useEffect } from 'react';
import { unescapeHtml } from '../../utils/stringUtils';
import { Template } from '../../pages/runtime-typechecker';
import { EPassPageTemplateData } from '../../pages/EPassPage/EpassPageDataChecker';
import { Context } from '../../AppContext';
const isSSR = typeof window === 'undefined';

type FooterSectionProps = {
  template: Template | EPassPageTemplateData;
};

const FooterSection = ({ template }: FooterSectionProps) => {
  const { trackTemplateEvent } = useContext(Context);
  useEffect(() => {
    const footerTopRoutes = document.getElementsByClassName(
      'footerTopRoutesFromCity'
    );
    for (let i = 0; i < footerTopRoutes.length; i++) {
      const footerRouteId = footerTopRoutes[i]['id'];
      footerTopRoutes[i].addEventListener(`click`, e => {
        trackTemplateEvent(`Cab_SEO_Footer_Route_${footerRouteId}_Click`);
      });
    }

    const footerCityLink = document.getElementsByClassName('footerCityLink');
    for (let i = 0; i < footerCityLink.length; i++) {
      const footerCityId = footerCityLink[i]['id'];
      footerCityLink[i].addEventListener(`click`, e => {
        trackTemplateEvent(`Cab_SEO_Footer_City_${footerCityId}_Click`);
      });
    }

    const staticFooterRoutes = document.getElementsByClassName(
      'footerStaticRoutes'
    );
    for (let i = 0; i < staticFooterRoutes.length; i++) {
      const footerRouteId = staticFooterRoutes[i]['id'];
      staticFooterRoutes[i].addEventListener(`click`, e => {
        trackTemplateEvent(`Cab_SEO_Footer_Route_${footerRouteId}_Click`);
      });
    }

    const staticFooterCities = document.getElementsByClassName(
      'footerStaticCity'
    );
    for (let i = 0; i < staticFooterCities.length; i++) {
      const footerCityId = staticFooterCities[i]['id'];
      staticFooterCities[i].addEventListener(`click`, e => {
        trackTemplateEvent(`Cab_SEO_Footer_City_${footerCityId}_Click`);
      });
    }
  }, []);
  const html = isSSR ? template.footerData : unescapeHtml(template.footerData);
  return (
    <footer
      className="footerWrap visibilityAuto"
      dangerouslySetInnerHTML={{
        __html: html
      }}
    />
  );
};
export default FooterSection;
